import React, { useState, useEffect } from 'react';

const useMediaQuery = () => {
  const [mediaQuery, setMediaQuery] = useState({
    isMobile: window.innerWidth <= 640,
    isTablet: window.innerWidth > 640 && window.innerWidth <= 1024,
    isDesktop: window.innerWidth > 1024,
  });

  useEffect(() => {
    const handleResize = () => {
      setMediaQuery({
        isMobile: window.innerWidth <= 740,
        isTablet: window.innerWidth <= 1024,
        isDesktop: window.innerWidth > 1024,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window.innerWidth]);

  return mediaQuery;
};

export default useMediaQuery;
